import { fetchGuestToken, fetchJwtTokens, setStoredTokens } from './repository';

import IdpHandler from '@user/IdpHandler';

const GIGYA_CLAIMS = ['email', 'firstName', 'lastName'];

/**
 * Retrieves a new authorization token, either a JWT token if the user is logged in, or a guest token if the user is not logged in.
 * It also store the new tokens in local storage.
 * @returns {Promise<{ authorisationToken: string, newRefreshToken: string }>} - An object containing the new authorization token and refresh token.
 */
export const getNewToken = async () => {
  const idp = await IdpHandler.waitIdpReady();
  if (idp.isLogged()) {
    const jwt = await idp.getJwtToken(GIGYA_CLAIMS);
    return getJwtTokens(jwt);
  } else {
    return getGuestTokens();
  }
};
const getJwtTokens = async (jwt: string) => {
  if (!jwt) return Promise.reject('No Jwt token provided');
  const response = await fetchJwtTokens(jwt);

  const { authorisationToken, refreshToken: newRefreshToken } = response.data;
  setStoredTokens(authorisationToken, newRefreshToken, 'logged');
  return { authorisationToken, newRefreshToken };
};
const getGuestTokens = async () => {
  const response = await fetchGuestToken();
  const { authorisationToken, refreshToken: newRefreshToken } = response.data;
  setStoredTokens(authorisationToken, newRefreshToken, 'guest');
  return { authorisationToken, newRefreshToken };
};
